export const DEFAULT_OPEN_GRAPH_LOCALES_BY_LANGUAGE = {
    en: "en_US",
    fr: "fr_CA",
    es: "es_US",
};
